import SurveyModal from "./SurveyModal"

export default SurveyModal



// WEBPACK FOOTER //
// ./src/Kiosk/SurveyModal/index.js